import { Injectable } from "@angular/core";
import { AppConfigService } from './appConfig.service';

@Injectable()
export class XocdiaService {
    constructor(private configService: AppConfigService) { }

    initXocdia1s(data = {}, nav: any) {
        data["flag"] = 'xocdia1sInit';
        return this.configService.initXocdia1s(data, nav);
    }

    xocdiaBet1s(data = {}, nav: any) {
        return this.configService.xocdiaBet1s(data, nav);
    }

    initXocdia1m(data = {}, nav: any) {
        data["flag"] = 'xocdia1mInit';
        return this.configService.initXocdia1m(data, nav);
    }

    xocdiaBet1m(data = {}, nav: any) {
        return this.configService.xocdiaBet1m(data, nav);
    }

    xocdiaHistoryTop(data = {}, nav: any) {
        data["flag"] = 'getopencodehistory';
        return this.configService.xocdiaHistoryTop(data, nav);
    }

    xocdia1mBetOpen(data = {}, nav: any) {
        return this.configService.xocdia1mBetOpen(data, nav);
    }
}


// WEBPACK FOOTER //
// ./src/services/xocdia.service.ts